import React from 'react';
import { reduxForm, Field } from 'redux-form';
import FormError from './FormError';
import InputField from './InputField';

const ConfirmSwitchSprintToAttForm = ({
  handleSubmit,
  errorMsg,
  successMsg,
}) => (
  <div>
    <form onSubmit={handleSubmit}>
      <Field component={InputField} name="first_name" label="First name*" />
      <Field component={InputField} name="last_name" label="Last name*" />
      <Field component={InputField} name="agent_id" label="Agent ID*" />
      <Field component={InputField} name="csa" label="Csa*" />
      <Field
        component={InputField}
        name="profile_image"
        label="Profile image*"
      />
      <Field
        component={InputField}
        name="intl_charge_threshold"
        label="Intl charge threshold*"
      />
      {errorMsg && <FormError error={errorMsg} />}
      {successMsg && <p className="text-success">{successMsg}</p>}
      <button className="btn btn-default">Start Switch</button>
    </form>
  </div>
);

const validate = (values) => {
  let errors = {};

  if (!values.first_name) {
    errors.first_name = 'Required';
  }
  if (!values.last_name) {
    errors.last_name = 'Required';
  }
  if (!values.agent_id) {
    errors.agent_id = 'Required';
  }
  if (!values.csa) {
    errors.csa = 'Required';
  }
  if (!values.intl_charge_threshold) {
    errors.intl_charge_threshold = 'Required';
  }
  return errors;
};

export default reduxForm({
  form: 'sprintToAttConfirmSwitch',
  validate,
})(ConfirmSwitchSprintToAttForm);
